import Component from './SliderLayout.vue';

export default Component;
